export function logClickEvent(linkId) {
    try {
        uitk.analytics.track('a', {linkObj: this, linkId: linkId});
    } catch(e) {
        uitk.logger.warn('Failed to log click event of type ' + linkId);
    }
}
    
export function logPanelBtnClickEvent(panelName, omnitureValue) {
    const panelBtnClicked = 'HelpCenter.Panel.' + panelName + omnitureValue;
    omnitureLog.logClickEvent(panelBtnClicked);
}

export function logClickEventWithTrackVars(linkId, trackVarsAndValue, trackVars) {
    try {
        for (const [key, value] of Object.entries(trackVarsAndValue)) {
            uitk.analytics.set(key, value);
        }
        uitk.analytics.track('a',{linkObj: this, linkId: linkId, linkTrackVars: trackVars});
    } catch(e) {
        uitk.logger.warn('Failed to log click event of type ' + linkId);
    }
}

window.omnitureLog = {
    logClickEvent,
    logPanelBtnClickEvent: (e, omnitureValue) => logPanelBtnClickEvent(e.currentTarget.dataset.panelViewName, omnitureValue),
    logClickEventWithTrackVars
};